<template>
  <div>
    <h3 class="title mb-3 green--text">Plano</h3>
    <p>
      <strong>N° Registro do Plano /SCPA: </strong
      >{{ beneficiarioPinss ? beneficiarioPinss.planoRegistroAns : "" }}
    </p>
    <p>
      <strong>Nome do Produto: </strong
      >{{ beneficiarioPinss ? beneficiarioPinss.planoNomeComercial : "" }}
    </p>
    <p>
      <strong>Tipo de Contratação: </strong
      >{{ beneficiarioPinss ? beneficiarioPinss.planoTipoContratacao : "" }}
    </p>
    <p>
      <strong>Segmentação: </strong
      >{{ beneficiarioPinss ? beneficiarioPinss.planoSegmentacao : "" }}
    </p>
    <p>
      <strong>Abrangência: </strong
      >{{
        beneficiarioPinss ? beneficiarioPinss.planoAbrangenciaGeografica : ""
      }}
    </p>
    <p>
      <strong>Acomodação: </strong
      >{{ beneficiarioPinss ? beneficiarioPinss.planoTipoAcomodacao : "" }}
    </p>
    <p>
      <strong>Regulamentação: </strong
      >{{ beneficiarioPinss ? beneficiarioPinss.planoCelebrado : "" }}
    </p>
    <p>
      <strong>Rede de Atendimento: </strong
      >{{ beneficiarioPinss ? beneficiarioPinss.planoRedeAtendimento : "" }}
    </p>
    <div v-if="mostrarDadosUltimoReajuste">
      <p>
        <strong>Participação financeira da contratante: </strong
        >{{ beneficiarioPinss ? beneficiarioPinss.contratacaoPlano : "" }}
      </p>
    </div>
  </div>
</template>

<script>
import { getParametro } from "@/services/beneficiario";

export default {
  name: "Beneficiario",
  props: {
    beneficiarioPinss: Object
  },
  data() {
    return {
      mostrarDadosUltimoReajuste: null
    };
  },
  created() {
    this.getParametroMostraUltimoReajuste();
  },
  methods: {
    async getParametroMostraUltimoReajuste() {
      const parametroId = 17;

      this.mostrarDadosUltimoReajuste =
        (await getParametro(parametroId)) === "true";
    }
  }
};
</script>

<style scoped lang="scss">
.pinss {
  p {
    margin-bottom: 8px;
  }
}
</style>
